import axios from 'axios';
import Vue from 'vue';

export default {
  namespaced: true,
  state() {
    return {
      list: null,
      answers: [],
      loaded: false,
      error: null,
      finish: false
    }
  },
  mutations: {
    set_list(state, v) { state.list = v; },
    set_loaded(state, v) { state.loaded = v; },
    set_error(state, v) { state.error = v; },
    set_finish(state, v) { state.finish = v; },
    update(state, data) {
      const ind = state.answers.findIndex(el => el.question_id === data.question_id);
      let answer = state.answers.find(el => el.question_id === data.question_id);

      if(answer) {
        answer = data;
        state.answers.splice(ind, 1, answer);
      } else {
        state.answers.push(data);
      }
    },
    remove_empty_answer(state, question_id) {
      state.answers = state.answers.filter(a => a.question_id !== question_id)
    },

    SET_OTHER_ANSWER(state, { questionId, newValue }) {
      const answerIndex = state.answers.findIndex(x => x.question_id == questionId);

      if (answerIndex >= 0) {
        if (newValue !== '') {
          Vue.set(state.answers[answerIndex], 'other', newValue);
        } else {
          Vue.delete(state.answers[answerIndex], 'other');
        }
      } else {
        state.answers.push({ question_id: questionId, other: newValue });
      }
    }
  },

  actions: {
    load(context, token) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      return axios.get(`1.0/interviews/${token}/survey`)
        .then(r => {
          context.commit('set_list', r.data.data[0]);
          context.commit('set_loaded', false);
          return r.data.data;
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          return Promise.reject(err);
        })
    },

    record(context, data) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      let { records, token } = data;

      return axios.post(`1.0/interviews/${token}/survey/records`, { answers: records })
        .then(r => {
          context.commit('set_loaded', false);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          return Promise.reject(err);
        })
    },


    finish(context, token) {
      context.commit('set_loaded', true);
      context.commit('set_error', null);

      return axios.put(`1.0/interviews/${token}/survey/finish`)
        .then(r => {
          context.commit('set_loaded', false);
          return r;
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);
          return Promise.reject(err);
        })
    }
  },
  getters: {
    list: state => state.list,
    answers: state => state.answers,
    getAnswersObject: state => questionId => {
      const index = state.answers.findIndex(x => x.question_id == questionId);

      if (index >= 0) {
        return state.answers[index];
      } else {
        return [];
      }
    },
    loaded: state => state.loaded,
    error: state => state.error,
    finish: state => state.finish
  }
};
